import { ROUTE_PATH as STORES_PAGE_PATH } from '@/features/storesPage/consts';

export const ROUTE_PATH = `${STORES_PAGE_PATH}/new`;

export const FEATURE_NAME = 'storeCreatePage';
